import { render, staticRenderFns } from "./CreateNewRoom.vue?vue&type=template&id=7cc2256c&"
import script from "./CreateNewRoom.vue?vue&type=script&lang=js&"
export * from "./CreateNewRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports